import React, { useState } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'

import DriverTracking from './DriverTracking'
import CustomerTracking from './CustomerTracking'
import LockTracking from './LockTracking'

const setFilter = (query) => (d) => {
  const regex = new RegExp(query, 'gi')

  return regex.test(d.name) || regex.test(d.phone)
}

const Tracking = () => {
  const [activeTab, setActiveTab] = useState('drivers')
  const [isLoading, setIsLoading] = useState(false)

  const { locks, customers, drivers, carriers } = useSelector((s) => s.collectionData)

  const getTrackingAlternatives = (param, options = {}) => {
    const byNameOrPhone = setFilter(options.query)

    const arr = param === 'customers' ? customers : drivers

    return arr.filter(byNameOrPhone)
  }

  const fetchTracking = (param, id, search) => {
    setIsLoading(true)

    const { userType } = window.localStorage

    let url = `${window.MYQLOCX_API}/subject/${userType}/tracking/${param}`

    if (id) url += `/${id}`
    else if (search) url += `?search=${search}`

    return axios
      .get(url)
      .then(({ data: { entries, ...data } }) => {
        setIsLoading(false)

        entries.forEach((e) => {
          const lock = locks.find((d) => e.lock && e.lock === d.lock)

          if (lock) e.lock = lock.custom_name

          return e
        })

        return {
          ...data,
          entries,
        }
      })
      .catch((e) => {
        setIsLoading(false)
        throw e
      })
  }

  return (
    <div>
      <div className="flex" style={{ justifyContent: 'flex-start' }}>
        <button className="Qbutton" onClick={() => setActiveTab('drivers')} style={{ padding: 20, background: activeTab === 'drivers' ? '#006e78' : '#fff', color: activeTab === 'drivers' ? '#fff' : '#000' }}>
          Chaufförer
        </button>
        <button className="Qbutton" onClick={() => setActiveTab('customers')} style={{ padding: 20, background: activeTab === 'customers' ? '#006e78' : '#fff', color: activeTab === 'customers' ? '#fff' : '#000' }}>
          Användare
        </button>
        <button className="Qbutton" onClick={() => setActiveTab('locks')} style={{ padding: 20, background: activeTab === 'locks' ? '#006e78' : '#fff', color: activeTab === 'locks' ? '#fff' : '#000' }}>
          Lås
        </button>
      </div>
      <DriverTracking isActive={activeTab === 'drivers'} isLoading={isLoading} carriers={carriers} drivers={drivers} getTrackingAlternatives={getTrackingAlternatives} fetchTracking={fetchTracking} />
      <CustomerTracking isActive={activeTab === 'customers'} isLoading={isLoading} getTrackingAlternatives={getTrackingAlternatives} fetchTracking={fetchTracking} />
      <LockTracking isActive={activeTab === 'locks'} isLoading={isLoading} />
    </div>
  )
}

export default Tracking
